/**
 * Redirects to the cart page after a successful product add-to-cart.
 * Enabled via Theme settings > Cart > redirect_to_cart_after_add.
 */
(() => {
  const ADD_SOURCES = new Set(['product-form-component', 'quick-order-quantity']);

  const shouldRedirect = (event) => {
    if (!Theme?.settings?.redirect_to_cart_after_add) return false;

    const cartUrl = Theme?.routes?.cart_url || '/cart';
    const cartPath = new URL(cartUrl, window.location.origin).pathname;
    if (window.location.pathname === cartPath || window.location.pathname.endsWith(cartPath)) {
      return false;
    }

    const data = event?.detail?.data;
    if (!data || data.didError) return false;
    if (!ADD_SOURCES.has(data.source)) return false;

    return true;
  };

  document.addEventListener('cart:update', (event) => {
    if (!shouldRedirect(event)) return;

    // Persist the page the shopper came from (history.back is unreliable here)
    try {
      sessionStorage.setItem('continueShoppingUrl', window.location.href);
    } catch {
      // ignore quota / private mode failures
    }

    const cartUrl = Theme?.routes?.cart_url || '/cart';
    window.location.assign(cartUrl);
  });
})();
